// src/config.js
const config = {
  BASE_URL: "https://api.themilkbar.co", // Use the actual base URL of your API
  // BASE_URL: "http://localhost:5000", // Use the actual base URL of your API
};

export default config;
